import mitt from 'mitt'

type Events = {
  focusQuoteFormFirstField: void
}

const eventBus = mitt<Events>()

export default eventBus
